import React, { useEffect, useState } from 'react';

import ButtonDefault from '../../../components/Buttons/ButtonDefault';
import CardImovel from '../../../components/Cards/CardImovel';
import CarouselCardsDefault from '../../../components/Carousel/CarouselCardsDefault';

import style from './sugestoes.module.scss';

export default function Sugestoes({ currentProduct, disponibilidade }) {
  const [arrayCarousel, setArrayCarousel] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const genArrayCarousel = async() => {
      const district = currentProduct?.bairro;
      const dormsMin = currentProduct?.dorms?.match(/\d+/g)[0];
      const minPrice = parseFloat(currentProduct.valorMinimo);

      // Ordem de classificação: bairro > dormitórios > valor

      const arrayOrdered = currentProduct.sort((a, b) => {
        if (a.bairro === district && b.bairro !== district) return -1;
        if (a.bairro !== district && b.bairro === district) return 1;
        if (a.bairro === b.bairro) {
          if (a.numeroDeDormitorios[0] >= dormsMin && b.numeroDeDormitorios[0] < dormsMin) return -1;
          if (a.numeroDeDormitorios[0] < dormsMin && b.numeroDeDormitorios[0] >= dormsMin) return 1;
          if (a.numeroDeDormitorios[0] === b.numeroDeDormitorios[0]) {
            if (a.precoMinimo <= minPrice && b.precoMinimo > minPrice) return -1;
            if (a.precoMinimo > minPrice && b.precoMinimo <= minPrice) return 1;

            return null;
          }
        }

        return null;
      });

      if (isMounted) {
        setArrayCarousel(arrayOrdered.slice(0, 5));
      }
    };

    genArrayCarousel();

    isMounted = false;
  }, [currentProduct, disponibilidade]);

  if (!currentProduct || !disponibilidade) return null;

  const arrayCards = arrayCarousel.map((imovel) => (
    <CardImovel
      key={imovel.id}
      imovel={imovel}
    />
  ));

  return (
    <div className={style.section}>
      <h2>Encontre o seu Apartamento</h2>
      <h4>Descubra as opções disponíveis!</h4>
      <ButtonDefault
        url='/apartamentos-a-venda'
        text='Ver todas as opções!'
        aria='Ver todas as opções!'
      />
      <CarouselCardsDefault seeMore='/apartamentos-a-venda'>{arrayCards}</CarouselCardsDefault>
    </div>
  );
}
